import React, { useState, useEffect } from 'react';
import { MdArrowBack, MdLockOutline, MdEmail, MdTranslate, MdChevronRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { ref, get, update } from "firebase/database";
import { db } from "../firebase";
import Swal from 'sweetalert2';
import './Settings.css';

const Settings = () => {
    const navigate = useNavigate();
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const savedUser = JSON.parse(localStorage.getItem('user'));
        if (savedUser) setCurrentUser(savedUser);
    }, []);

    // 1. Password Change Logic
    const handleChangePassword = async () => {
        const { value: formValues } = await Swal.fire({
            title: 'Change Password',
            html:
                '<input id="oldPass" class="swal2-input" placeholder="Old Password" type="password">' +
                '<input id="newPass" class="swal2-input" placeholder="New Password" type="password">',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#f3ba2f',
            preConfirm: () => {
                return [
                    document.getElementById('oldPass').value,
                    document.getElementById('newPass').value
                ]
            }
        });

        if (formValues) {
            const [oldPass, newPass] = formValues;
            if (!oldPass || !newPass) return Swal.fire('Error', 'Fields cannot be empty', 'error');

            const userRef = ref(db, `users/${currentUser.username}`);
            const snapshot = await get(userRef);
            
            if (snapshot.exists() && snapshot.val().password === oldPass) {
                await update(userRef, { password: newPass });
                Swal.fire('Success', 'Password updated successfully!', 'success');
            } else {
                Swal.fire('Error', 'Old password is incorrect', 'error');
            }
        }
    };

    // 2. Email Change Logic
    const handleUpdateEmail = async () => {
        const { value: newEmail } = await Swal.fire({
            title: 'Update Email',
            input: 'email',
            inputLabel: 'Enter your new email address',
            inputPlaceholder: 'example@gmail.com',
            showCancelButton: true,
            confirmButtonColor: '#f3ba2f',
        });

        if (newEmail) {
            try {
                const userRef = ref(db, `users/${currentUser.username}`);
                await update(userRef, { email: newEmail });
                
                // LocalStorage update taaki Profile par bhi change dikhe
                const updatedLocal = { ...currentUser, email: newEmail };
                localStorage.setItem('user', JSON.stringify(updatedLocal));
                setCurrentUser(updatedLocal);

                Swal.fire('Success', 'Email updated successfully!', 'success');
            } catch (e) {
                Swal.fire('Error', 'Failed to update email', 'error');
            }
        }
    };

    return (
        <div className="settings-page-wrapper">
            <div className="settings-nav">
                <MdArrowBack onClick={() => navigate(-1)} className="nav-icon" />
                <span>Account Settings</span>
                <div style={{ width: '24px' }}></div>
            </div>

            <div className="settings-content">
                <div className="settings-group-label">Security & Privacy</div>
                
                {/* Change Password */}
                <div className="settings-item" onClick={handleChangePassword}>
                    <div className="settings-item-left">
                        <div className="settings-icon-bg"><MdLockOutline /></div>
                        <div className="settings-text">
                            <strong>Change Password</strong>
                            <p>Update your login security</p>
                        </div>
                    </div>
                    <MdChevronRight className="arrow-right" />
                </div>

                {/* Update Email */}
                <div className="settings-item" onClick={handleUpdateEmail}>
                    <div className="settings-item-left">
                        <div className="settings-icon-bg"><MdEmail /></div>
                        <div className="settings-text">
                            <strong>Update Email</strong>
                            <p>{currentUser?.email || 'Change your registered email'}</p>
                        </div>
                    </div>
                    <MdChevronRight className="arrow-right" />
                </div>

                {/* Language (Static for now) */}
                <div className="settings-item">
                    <div className="settings-item-left">
                        <div className="settings-icon-bg"><MdTranslate /></div>
                        <div className="settings-text">
                            <strong>Language</strong>
                            <p>English (Default)</p>
                        </div>
                    </div>
                    <MdChevronRight className="arrow-right" />
                </div>

                <div className="settings-info-box">
                    <p>App Version: 2.0.4 (Stable)</p>
                    <p>Last Login: 4/23/2026</p>
                </div>
            </div>
        </div>
    );
};

export default Settings;